// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d-grid[data-v-60bba3e5]{grid-template-columns:30px 1fr}.icon-nutrition[data-v-60bba3e5]{width:30px;height:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
